@if (view != null) {
    <div class="table-responsive w-100">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th
                        app-sortable-table-header
                        [column]="'buildingNo'"
                        (sort)="onSort($event)"
                        [label]="'properties_systemNo' | translate: 'online' : 'systems'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'buildingName'"
                        (sort)="onSort($event)"
                        [label]="'properties_systemName' | translate: 'online' : 'systems'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'address'"
                        (sort)="onSort($event)"
                        [label]="'properties_address' | translate: 'online' : 'systems'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'alloUnitType'"
                        (sort)="onSort($event)"
                        [label]="'common_USAGE' | translate: 'online' : 'common'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'meterType'"
                        (sort)="onSort($event)"
                        [label]="'properties_meterType' | translate: 'online' : 'systems'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'unit'"
                        (sort)="onSort($event)"
                        [label]="'reporting_UNIT' | translate: 'online' : 'ngonline'"></th>
                    @if (view[0] != null) {
                        @for (consumptionReport of view[0].consumptions; track $index) {
                            <th>
                                {{ consumptionReport.fromDate | appdateshortyear }} - <br />
                                {{ consumptionReport.toDate | appdateshortyear }}
                            </th>
                        }
                    }
                </tr>
            </thead>
            <tbody>
                @for (
                    report of view | slice: (page - 1) * pageSize : page * pageSize;
                    track report
                ) {
                    <tr>
                        <td>{{ report.buildingNo }}</td>
                        <td>{{ report.buildingName }}</td>
                        <td class="text-nowrap">{{ report.address }}</td>
                        <td>
                            {{
                                'mappers_allocationUnitMap.' + report.alloUnitType
                                    | translate: 'online' : 'common'
                            }}
                        </td>
                        <td>
                            {{
                                'mappers_meterType.' + report.meterType
                                    | translate: 'online' : 'common'
                            }}
                        </td>
                        <td>
                            {{
                                'mappers_measurementUnit.' + report.unit
                                    | translate: 'online' : 'common'
                            }}
                        </td>
                        @for (consumptionReport of report.consumptions; track $index) {
                            <td>
                                @if (consumptionReport.consumption != null) {
                                    {{ consumptionReport.consumption | appnumber }}
                                }
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
